import makeStyles from "e100-react-components/lib/styles/makeStyles";

export const useStyles = makeStyles(({ spacing }) => ({
  avatar: {
    color: "#515B69",
    backgroundColor: "rgba(81, 91, 105, 0.1)",
  },
  contentRoot: {
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
  },
  itemPadding: {
    paddingBottom: spacing(0.5),
  },
  itemText: {
    flexGrow: 2,
  },
  battery: {
    transform: "translate(0, -2px) rotate(90deg)",
    color: "#515B69",
  },
  container: {
    height: '100%'
  },
  activeService: {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    marginTop: spacing(2),
    marginBottom: spacing(),
    paddingLeft: spacing(2),
    paddingRight: spacing(2)
  }
}));
